import { initHelpers } from "./helpers";
//import { initAnimatedHeadings } from "../core/helpers";
import { setOffScreenState } from "../core/helpers";
import { animateIn } from "../core/helpers";
import { initLoader } from "../core/helpers";
import { pageTransitionIn } from "../core/helpers";
import { pageTransitionOut } from "../core/helpers";
import { initWindowInnerheight } from "../core/helpers";
import { initCheckTouchDevice } from "../core/helpers";
import { initCookieViews } from "../core/helpers";
import { initTricksWords } from "../core/helpers";
import { initLazyLoad } from "../core/helpers";
import { playVideoInview } from "../core/helpers";
import { initGoogleTranslate } from "../core/helpers";
//import { initFilter } from "../components/filter";
import { initOpcionesDinamicas } from "../components/filter";
import { initScrolltriggerNav } from "../components/hamburger";
import { initHamburgerNav } from "../components/hamburger";
//import { submenumob } from "../components/hamburger";
import { initSmoothScroll } from "../barba/smoothScroll";
import { initScrolltriggerAnimations } from "../components/scrollAnimations";
import { initSwiper } from "../components/swiper";
//import { initMarqueeDrag } from "../components/swiper";
//import { initGaleriaMobile } from "../components/swiper";
import { initPopups } from "../components/popups";
import { initOtros } from "../components/otros";
import { initWoo } from "../components/woo";
//import { productQuantity } from "../components/otros";
//import { initMapaActividades } from "../components/mapa";

export function initScript() {

    initHelpers();
    // initAnimatedHeadings();
    setOffScreenState();
    animateIn();
    //initLoader();
    //pageTransitionIn();
    //pageTransitionOut();
    initWindowInnerheight();
    initCheckTouchDevice();
    initCookieViews();
    initTricksWords();
    initLazyLoad();
    playVideoInview();

    //initFilter();
    //initOpcionesDinamicas();

    initHamburgerNav();
    //    submenumob();

    initScrolltriggerNav();

    initSmoothScroll();

    // if ($("#mapa-actividades").length) {
    //     initMapaActividades();
    // }
    initScrolltriggerAnimations();
    initPopups();
    initSwiper();
    //initMarqueeDrag();
    //initGaleriaMobile();
    initOtros();
    initWoo();
    //initGoogleTranslate();
    //productQuantity();

}
